/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsCustomerAnalytics
 */
export interface AllShipmentsCustomerAnalytics {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsCustomerAnalytics
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof AllShipmentsCustomerAnalytics
   */
  companyName?: string | null;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCustomerAnalytics
   */
  shipmentCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCustomerAnalytics
   */
  bookedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCustomerAnalytics
   */
  conversionRate: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCustomerAnalytics
   */
  totalRevenue: number;
}

/**
 * Check if a given object implements the AllShipmentsCustomerAnalytics interface.
 */
export function instanceOfAllShipmentsCustomerAnalytics(
  value: object,
): value is AllShipmentsCustomerAnalytics {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("shipmentCount" in value) || value["shipmentCount"] === undefined)
    return false;
  if (!("bookedCount" in value) || value["bookedCount"] === undefined)
    return false;
  if (!("conversionRate" in value) || value["conversionRate"] === undefined)
    return false;
  if (!("totalRevenue" in value) || value["totalRevenue"] === undefined)
    return false;
  return true;
}

export function AllShipmentsCustomerAnalyticsFromJSON(
  json: any,
): AllShipmentsCustomerAnalytics {
  return AllShipmentsCustomerAnalyticsFromJSONTyped(json, false);
}

export function AllShipmentsCustomerAnalyticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsCustomerAnalytics {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"] == null ? undefined : json["companyName"],
    shipmentCount: json["shipmentCount"],
    bookedCount: json["bookedCount"],
    conversionRate: json["conversionRate"],
    totalRevenue: json["totalRevenue"],
  };
}

export function AllShipmentsCustomerAnalyticsToJSON(
  json: any,
): AllShipmentsCustomerAnalytics {
  return AllShipmentsCustomerAnalyticsToJSONTyped(json, false);
}

export function AllShipmentsCustomerAnalyticsToJSONTyped(
  value?: AllShipmentsCustomerAnalytics | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
    shipmentCount: value["shipmentCount"],
    bookedCount: value["bookedCount"],
    conversionRate: value["conversionRate"],
    totalRevenue: value["totalRevenue"],
  };
}
